<template>
  <div>
    <v-dialog v-model="show" :max-width="width" flat elevation="0" persistent>
      <v-card color="greyColorLigthTwo" class="rounded-lg py-5 px-5">
        <v-card-title
          class="defaultColor--text font-weight-medium text-center px-4 justify-center"
          style="
            font-size: 20px;
            line-height: 28px;
            width: 100%;
            word-break: normal;
          "
        >
          <img
            @click="gotoPage('google')"
            width="280"
            :src="require('../../../public/images/bsp-logo.png').default"
            class="imgClass mb-7"
          />
          {{ $t("description.downloadAppInStore", { name: "BSP+" }) }}
        </v-card-title>

        <v-card-actions
          class="justify-center align-center pb-5 mt-6 flex-column"
        >
          <img
            @click="gotoPage('google')"
            width="200px"
            :src="
              require('../../../public/images/store/googleplaystore.png')
                .default
            "
            class="imgClass"
          />
          <img
            @click="gotoPage('apple')"
            width="200px"
            :src="require('../../../public/images/store/appstore.png').default"
            class="imgClass mt-5"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      width: 330,
    };
  },
  props: {
    visible: Boolean,
  },
  mounted() {
    this.detectmob();
  },
  components: {},
  methods: {
    gotoPage(val) {
      if (val == "google")
        window.location.href = "https://play.google.com/store/apps/details?id=com.gri.bsp";
      else if (val == "apple")
        window.location.href = "https://apps.apple.com/us/app/bsp/id1227859668";
    },

    detectmob() {
      if (navigator.userAgent.match(/Android/i)) {
        this.gotoPage("google");
      } else if (
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i)
      ) {
        this.gotoPage("apple");
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {},
    },
  },
  watch: {},
};
</script>
